import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import './scss/Comments.scss';
import ImagePlaceholder from '../Global/ImagePlaceholder';
import { sanitizeHtml, timeAgo } from '../../utils/helpers';
import { config } from '../../config';

import {
    mentionedMemberIds,
    resetMentionedIds,
} from "../../redux/Slices/mentionedSlice";
import { fetchCardById } from '../../redux/Slices/cardSlice';
import { addCommentOptimistically, fetchActivities, finalizeCommentOptimistically, setCommentPostingState, deleteCommentOptimistically, setHighlightTarget } from '../../redux/Slices/activitiesSlice';
import Editor from '../LexicalEditor/Editor';
import ActivityZone from '../icons/ActivityZone';

const Comments = ({ cardId, isActivityDetails, layout = '', isEditingDescription, isReadOnly = false }) => {
    const { user, loading: userLoading, error: userError } = useSelector((state) => state.user);
    // const { activities, activitiesLoading: loading } = useSelector((state) => state.activities);

    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const [editingComment, setEditingComment] = useState('');
    const [isAddComment, setAddComment] = useState('');
    const [isCommentBoxClicked, setCommentBoxClicked] = useState(true);


    const dispatch = useDispatch();

    const mentionedIds = useSelector((state) => state.mentioned.mentionedMemberIds);

    // useEffect(() => {
    //     fetchComments();
    // }, [cardId]);



    const fetchComments = async () => {
        
        try {
            const response = await fetch(config.API_URI + `/v1/cards/${cardId}/comments`, {
                
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error('Failed to fetch comments');
            }

            const data = await response.json();
            setComments(data);
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
    };

    const handleAddComment = async (e) => {
        if (!newComment.trim()) return;

        const commentText = newComment;
        setNewComment(''); // Clear input for better experience (or keep it and wait?)
        setAddComment(false);

        try {
            const response = await fetch(`${config.API_URI}/v1/cards/${cardId}/comments`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    comment: commentText,
                    member: user?.user?._id,
                    reacts: [],
                    mentionedIds,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to add comment');
            }

            const addedComment = await response.json();

            // Create the new comment object and dispatch after success
            const newCommentData = {
                _id: addedComment.commentId || Date.now(),
                details: commentText,
                initiator: {
                    _id: user?.user?._id,
                    name: user?.user?.name,
                    profilePicture: user?.user.profilePicture,
                },
                createdAt: new Date().toISOString(),
                actionType: 'ADDED_COMMENT',
                actionTypeId: addedComment.commentId,
                isPosting: false,
            };

            dispatch(addCommentOptimistically(newCommentData));

            // Highlight this new comment after fetch
            if (addedComment?.commentId) {
                dispatch(setHighlightTarget({ type: 'comment', id: addedComment.commentId }));
            }

            // Fetch activities to get the real server data
            dispatch(fetchActivities({ cardId, isActivityDetails }));
            dispatch(resetMentionedIds());
        } catch (error) {
            console.error('Error adding comment:', error);
            // Restore the input on error
            setNewComment(commentText);
            setAddComment(true);
        }
    };




    return (
        <div className={`comment-section${' ' + layout}`}>


            {
                layout !== 'collumn' && (
                    <div className="activity-header">
                        <h3>
                            <ActivityZone size={24} />
                            Comments & Activity
                        </h3>
                    </div>
                )
            }
            {!isReadOnly && (
                <div className="comment comment-input-field">

                    {
                        layout !== 'collumn' && (
                            <>
                                {user?.user.profilePicture ? (
                                    <img src={user?.user.profilePicture} alt={user?.user.username} className="comment__profile-img" loading="lazy" />
                                ) : (
                                    <ImagePlaceholder text={user?.user.username} onlineIndicator={false} />
                                )}

                            </>
                        )
                    }

                    <div className={`comment__content comment-editor-field`}>
                        <div className="comment__actions">
                            {
                                isAddComment ? (
                                    <>
                                        {
                                            layout == 'collumn' && (
                                                <div className='comment-by__header'>
                                                    {user?.user.profilePicture ? (
                                                        <img src={user?.user.profilePicture} alt={user?.user.username} className="comment__profile-img" loading="lazy" />
                                                    ) : (
                                                        <ImagePlaceholder size={10} text={user?.user.username} onlineIndicator={false} />
                                                    )}

                                                    <div className='comment-by'>
                                                        <strong>{user?.user.name}</strong>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <Editor
                                            value={newComment}
                                            setDescription={setNewComment}
                                            setIsEditingDescription={setAddComment}
                                            handleUpdateCard={handleAddComment}
                                            cardId={cardId}
                                            context="comment"
                                        />
                                    </>

                                ) : (
                                    <div className="card-comment-content write-comment-field" onClick={() => setAddComment(true)}>
                                        Write a comment...
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Comments;
